<template>
    <div class="modal">
        <div class="modal__container">
            <div class="modal__wrapper">
                <h3 class="modal__title">
                    <slot name="title">Title</slot>
                </h3>

                <slot name="content">
                    <p>Content</p>
                </slot>

                <div class="modal__actions">
                    <slot name="actions">
                        <button>Button</button>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalComponent'
}
</script>